import ViewportGridService from './ViewportGridService';
import type { PresentationIds } from './ViewportGridService';

export default ViewportGridService;
export type { PresentationIds };
